import type React from 'react';
import { useState } from 'react';
import { getCurrentUser } from '../../../services/CurrentUser';
import type { IconOffset } from '../../AddUpgradeIcon';
import AddUpgradeIcon from '../../AddUpgradeIcon';
import Modal from '../../Modal';
import UpgradePlanContent from './UpgradePlanContent';
import styles from './styles.m.less';

type UpgradePlanModalProps = {
    isOpen: boolean;
    onClose(): void;
};

export type ButtonWithUpgradePlanModalProps = {
    disabled: boolean;
    TriggerButton: React.FC<{ disabled: boolean }>;
    buttonProps?: Record<string, string>;
    iconOffset?: IconOffset;
    showUpgradeIcon?: boolean;
    upgradePlanModal?: React.ComponentType<UpgradePlanModalProps>;
};

const ButtonWithUpgradePlanModal = ({
    TriggerButton,
    disabled,
    buttonProps,
    showUpgradeIcon = true,
    upgradePlanModal: CustomUpgradePlanModal,
}: ButtonWithUpgradePlanModalProps) => {
    const [showModal, setShowModal] = useState(false);
    const currentUser = getCurrentUser();
    const customerPlan = currentUser.company.payment.plan;

    const handleButtonClick = () => {
        if (disabled) {
            setShowModal(prev => !prev);
        }
    };
    const modalContent = CustomUpgradePlanModal ? (
        <CustomUpgradePlanModal isOpen={showModal} onClose={() => setShowModal(false)} />
    ) : (
        <Modal isOpen={showModal} className={styles.upgradeModal} onClose={() => setShowModal(false)}>
            <UpgradePlanContent currentPlan={customerPlan} />
        </Modal>
    );

    const buttonContent = (
        <>
            {showUpgradeIcon ? (
                <AddUpgradeIcon>
                    <TriggerButton {...buttonProps} disabled={disabled} />
                </AddUpgradeIcon>
            ) : (
                <TriggerButton {...buttonProps} disabled={disabled} />
            )}
        </>
    );

    return disabled ? (
        <>
            {modalContent}
            <div
                role="button"
                onClick={handleButtonClick}
                className={styles.upgradeButtonContainer}
                style={{ cursor: 'pointer' }}
            >
                {buttonContent}
            </div>
        </>
    ) : (
        <TriggerButton {...buttonProps} disabled={disabled} />
    );
};

export default ButtonWithUpgradePlanModal;
